import { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const CommissionStateTdsPtaxDetails = ({
  month,
  year,
  allotMonth,
  allotYear,
  distMonthName,
  alotMonthName,
  distCode,
  userRole,
}) => {
  const [loading, setLoading] = useState([]);
  const [stateAbsCommission, setStateAbsCommission] = useState([]);
  const [submitMessage, setSubmitMessage] = useState("");
  const [error, setError] = useState(null);
  const [commissionData, setCommissionData] = useState([]);
  const [showButtonData, setShowButtonData] = useState(null);
  const allowedRoles = ["1", "9", "10"];

  useEffect(() => {
    const fetCommissionCost = async () => {
      try {
        setLoading(true);
        const commissioncostresponse = await fetch(
          `${process.env.REACT_APP_URL}/api/commission/commission-cost`
        );

        if (!commissioncostresponse.ok) {
          throw new Error("Failed to fetch State commission data");
        }

        const data = await commissioncostresponse.json();
        setCommissionData(data);
      } catch (error) {
        console.error("Fetch Error:", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetCommissionCost();
  }, []);

  useEffect(() => {
    const fetchStateCommissionAbstractDetails = async () => {
      try {
        setSubmitMessage("");
        setLoading(true);

        const stateCommissionResponse = await fetch(
          `${process.env.REACT_APP_URL}/api/commission/state-commission-abstract?month=${month}&year=${year}&alotMonth=${allotMonth}&alotYear=${allotYear}&distCode=${distCode}`
        );

        if (!stateCommissionResponse.ok) {
          throw new Error("Failed to fetch state commission abstract");
        }
        const data = await stateCommissionResponse.json();
        setStateAbsCommission(data);
      } catch (error) {
        console.error("Fetch Error:", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchStateCommissionAbstractDetails();
  }, [month, year, allotMonth, allotYear, distCode]);

  const totals = stateAbsCommission.reduce(
    (acc, item) => {
      acc.riceQty += Number(item.riceQty) || 0;
      acc.commissionAmount += Number(item.commissionAmount) || 0;
      acc.stateQty += Number(item.stateQty) || 0;
      acc.nfsaQty += Number(item.nfsaQty) || 0;
      acc.totalQty += Number(item.totalQty) || 0;
      acc.amount += Number(item.amount) || 0;
      acc.amountPayable += Number(item.amountPayable) || 0;
      acc.tds += Number(item.tds) || 0;
      acc.ptax += Number(item.ptax) || 0;
      acc.sbiFinal += Number(item.sbiFinal) || 0;
      acc.nonSbiFinal += Number(item.nonSbiFinal) || 0;
      acc.finalCommission += Number(item.finalCommission) || 0;
      acc.count += 1;
      return acc;
    },
    {
      riceQty: 0,
      commissionAmount: 0,
      stateQty: 0,
      nfsaQty: 0,
      totalQty: 0,
      amount: 0,
      amountPayable: 0,
      tds: 0,
      ptax: 0,
      sbiFinal: 0,
      nonSbiFinal: 0,
      finalCommission: 0,
      count: 0,
    }
  );

  

  const fetchCommissionStatus = async () => {
    try {
      setLoading(true);

      const queryParams = new URLSearchParams({
        month,
        year,
        allotMonth,
        allotYear,
        distCode,
        userRole,
        nfsaStateFlag: "STATE",
      });
      const commissionStatusResponse = await fetch(
        `${process.env.REACT_APP_URL}/api/commission/commision-status?${queryParams}`
      );

      if (!commissionStatusResponse.ok) {
        throw new Error("Failed to fetch NFSA commission status data");
      }

      const data = await commissionStatusResponse.json();
      setShowButtonData(data);
    } catch (error) {
      console.error("Fetch Error:", error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      if (!distCode || distCode === "0") {
        return;
      }
      fetchCommissionStatus();
    }, [distCode, month, year, allotMonth, allotYear, userRole]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }

  if (stateAbsCommission.length === 0) {
    return (
      <div className="mainhead" align="center">
        No data found
      </div>
    );
  }

   

  const handleSubmit = async (e) => {
    e.preventDefault();

    const distName = stateAbsCommission[0]?.distNameEn || "Unknown";
    const nfsaStateStatus = "STATE";
    const payload = new URLSearchParams({
      month,
      year,
      allotMonth,
      allotYear,
      distCode,
      userRole,
      distMonthName,
      alotMonthName,
      distName,
      nfsaStateStatus,
    });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_URL}/api/commission/update-commission-timestamp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: payload.toString(),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit verification.");
      }

      const data = await response.text();
      setSubmitMessage(data);
      if (!distCode || distCode !== "0") {
        fetchCommissionStatus();
      }
    } catch (error) {
      console.error("Submit Error:", error);
      setSubmitMessage("Submission failed. Please try again.");
    }
  };



  const handleDownloadExcel = async(data) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("State Commission Abstract");

  const totalColumns = 14;

  // === Row 1: Title ===
  worksheet.mergeCells(1, 1, 1, totalColumns);
  const titleCell = worksheet.getCell("A1");
  titleCell.value = "Monthly FPS Dealer Commission Report (SNA-SPARSH STATE Format)";
  titleCell.font = { size: 12, bold: true };
  titleCell.alignment = { horizontal: "center", vertical: "middle" };

  // === Row 2: First part of header ===
  worksheet.mergeCells("A2:A3"); // S.No
  worksheet.getCell("A2").value = "S.No";

  worksheet.mergeCells("B2:B3"); // District
  worksheet.getCell("B2").value = "District";

  worksheet.mergeCells("C2:C3"); // NFSA Qty
  worksheet.getCell("C2").value = "NFSA Qty of Rice Distributed (A)";

  worksheet.mergeCells("D2:D3"); // Amount Payable
  worksheet.getCell("D2").value = `Amount Payable Towards Commission\n(In Rs ${commissionData?.nfsaStateCost || 0} per kg)\n(B=A*${commissionData?.nfsaStateCost || 0})`;

  worksheet.mergeCells("E2:N2"); // State Commission
  worksheet.getCell("E2").value = "State Commission";

  // === Row 3: Subheaders under "State Commission" ===
  const subHeaders = [
    "State Qty of rice distributed (C)",
    "NFSA Add Qty of rice distributed (D)",
    "Total Qty (E=C+D)",
    `Amount (F=E*${commissionData?.stateCost || 0})`,
    "Total Amount Payable (G = B+F)",
    "TDS",
    "PT",
    "SBI Final Commission",
    "Non-SBI Final Commission",
    "Final Commission",
  ];

  subHeaders.forEach((header, index) => {
    worksheet.getCell(3, 5 + index).value = header; // Starts from column E (5)
  });

  // Apply styles to header (row 2)
  [2, 3].forEach((rowNumber) => {
  const row = worksheet.getRow(rowNumber);
  row.font = { bold: true };
  row.alignment = { horizontal: "center", vertical: "middle", wrapText: true };

  row.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFDDDDDD" },
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });
});

  // === Add Data Rows ===
  data.forEach((item, index) => {
   const row = worksheet.addRow([
      index + 1,
      item.distNameEn,
      parseFloat(item.riceQty.toFixed(3)),
      parseFloat(item.commissionAmount.toFixed(2)),
      parseFloat(item.stateQty.toFixed(3)),
      parseFloat(item.nfsaQty.toFixed(3)),
      parseFloat(item.totalQty.toFixed(3)),
      parseFloat(item.amount.toFixed(2)),
      parseFloat(item.amountPayable.toFixed(2)),
      parseFloat(item.tds.toFixed(2)),
      parseFloat(item.ptax.toFixed(2)),
      parseFloat(item.sbiFinal.toFixed(2)),
      parseFloat(item.nonSbiFinal.toFixed(2)),
      parseFloat(item.finalCommission.toFixed(2)),
    ]);

     // Left align first 10 columns
      for (let i = 1; i <= 2; i++) {
        row.getCell(i).alignment = { horizontal: "left" };
      }
      // Right align columns 11 to 19
      for (let i = 3; i <= 13; i++) {
        row.getCell(i).alignment = { horizontal: "right" };
      }
  });


  // Add total values row
    const totalRow = worksheet.addRow([
      "",
      "Total",
      totals.riceQty.toFixed(3),
      totals.commissionAmount.toFixed(2),
      totals.stateQty.toFixed(3),
      totals.nfsaQty.toFixed(3),
      totals.totalQty.toFixed(3),
      totals.amount.toFixed(2),
      totals.amountPayable.toFixed(2),
      totals.tds.toFixed(2),
      totals.ptax.toFixed(2),
      totals.sbiFinal.toFixed(2),
      totals.nonSbiFinal.toFixed(2),
      totals.finalCommission.toFixed(2)
    ]);

    // Style total row
    totalRow.font = { bold: true };
    totalRow.alignment = { horizontal: "right" };
    totalRow.getCell(1).alignment = { horizontal: "left" };

    totalRow.eachCell((cell, colNumber) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "double" },
        right: { style: "thin" },
      };
      // Keep alignment consistent for merged cells
      if (colNumber <= 2) {
        cell.alignment = { horizontal: "left" };
      }
    });

  

  // === Save File ===
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `State_Wise_Commission.xlsx`);
  }

  return (
  <>
    {submitMessage && (
        <div
          className="mainhead"
          align="center"
          style={{
            textDecoration: "none",
            marginTop: "5px",
            marginBottom: "20px",
          }}
        >
          {submitMessage}
        </div>
      )
    }

    <div style={{ justifyContent: "center", marginBottom: "70px" }}>
      <table width="90%" border="1" cellPadding="5" cellSpacing="0">
        <thead>
          <tr className="tableheader">
            <th colSpan={14}>
              Monthly FPS Dealer Commission Report (SNA-SPARSH STATE Format)
            </th>
          </tr>
          <tr className="tableheader">
            <th rowSpan={2}>S.No</th>
            <th rowSpan={2}>District</th>
            <th rowSpan={2}>
              NFSA <br /> Qty of Rice Distributed{" "}
              <font style={{ color: "orange" }}>(A)</font>
            </th>
            {
              <th rowSpan={2}>
                Amount Payable Towards Commission <br /> (In Rs
                {commissionData.nfsaStateCost || 0} per kg) <br />{" "}
                <font style={{ color: "orange" }}>
                  (B=A*{commissionData.nfsaStateCost || 0})
                </font>
              </th>
            }
            <th colSpan={10}>State Commission</th>
          </tr>
          <tr className="tableheader">
            <th>
              State Qty of rice distributed <br />{" "}
              <font style={{ color: "orange" }}>(C)</font>
            </th>
            <th>
              NFSA Add Qty of rice distributed
              <br />
              <font style={{ color: "orange" }}>(D)</font>
            </th>
            <th>
              Total Qty
              <br />
              <font style={{ color: "orange" }}>(E=C+D)</font>
            </th>
            <th>
              Amount <br />
              <font style={{ color: "orange" }}>
                (F=E*{commissionData.stateCost})
              </font>
            </th>
            <th>
              Total Amount Payable <br />
              <font style={{ color: "orange" }}>(G = B+F)</font>
            </th>
            <th>TDS</th>
            <th>PT</th>
            <th>SBI Final Commission</th>
            <th>Non-SBI Final Commission</th>
            <th>Final Commission</th>
          </tr>
        </thead>
        <tbody>
          {stateAbsCommission.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.distNameEn}</td>
              <td style={{ textAlign: "right" }}>{item.riceQty.toFixed(3)}</td>
              <td style={{ textAlign: "right" }}>
                {item.commissionAmount.toFixed(2)}
              </td>
              <td style={{ textAlign: "right" }}>{item.stateQty.toFixed(3)}</td>
              <td style={{ textAlign: "right" }}>{item.nfsaQty.toFixed(3)}</td>
              <td style={{ textAlign: "right" }}>{item.totalQty.toFixed(3)}</td>
              <td style={{ textAlign: "right" }}>{item.amount.toFixed(2)}</td>
              <td style={{ textAlign: "right" }}>
                {item.amountPayable.toFixed(2)}
              </td>
              <td style={{ textAlign: "right" }}>{item.tds.toFixed(2)}</td>
              <td style={{ textAlign: "right" }}>{item.ptax.toFixed(2)}</td>
              <td style={{ textAlign: "right" }}>{item.sbiFinal.toFixed(2)}</td>
              <td style={{ textAlign: "right" }}>
                {item.nonSbiFinal.toFixed(2)}
              </td>
              <td style={{ textAlign: "right" }}>
                {item.finalCommission.toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr style={{ fontWeight: "bold" }} className="tableheader">
            <td colSpan={2} style={{ textAlign: "center" }}>
              Total
            </td>
            <td style={{ textAlign: "right" }}>{totals.riceQty.toFixed(3)}</td>
            <td style={{ textAlign: "right" }}>
              {" "}
              {totals.commissionAmount.toFixed(2)}
            </td>
            <td style={{ textAlign: "right" }}>{totals.stateQty.toFixed(3)}</td>
            <td style={{ textAlign: "right" }}>{totals.nfsaQty.toFixed(3)}</td>
            <td style={{ textAlign: "right" }}>{totals.totalQty.toFixed(3)}</td>
            <td style={{ textAlign: "right" }}>{totals.amount.toFixed(2)}</td>
            <td style={{ textAlign: "right" }}>
              {totals.amountPayable.toFixed(2)}
            </td>
            <td style={{ textAlign: "right" }}>{totals.tds.toFixed(2)}</td>
            <td style={{ texAlign: "right" }}>{totals.ptax.toFixed(2)}</td>
            <td style={{ textAlign: "right" }}>{totals.sbiFinal.toFixed(2)}</td>
            <td style={{ textAlign: "right" }}>
              {" "}
              {totals.nonSbiFinal.toFixed(2)}
            </td>
            <td style={{ textAlign: "right" }}>
              {totals.finalCommission.toFixed(2)}
            </td>
          </tr>
        </tfoot>
      </table>
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          {
            <button
              onClick={() => handleDownloadExcel(stateAbsCommission)}
              className="button button2"
            >
              Download Excel
            </button>
          }

          { allowedRoles.includes(userRole) && distCode &&
            distCode !== "0" &&
            (showButtonData?.status === -1 ? (
              <>
                <br />
                <br />
                <div className="mainhead" style={{ textDecoration: "none" }}>
                  {showButtonData?.message}
                </div>
              </>
            ) : showButtonData?.showForm ? (
              <form onSubmit={handleSubmit} style={{ display: "inline" }}>
                <input type="hidden" name="month" value={month} />
                <input type="hidden" name="year" value={year} />
                <input type="hidden" name="alotmonth" value={allotMonth} />
                <input type="hidden" name="alotyear" value={allotYear} />
                <input type="hidden" name="dist_code" value={distCode} />
                <button
                  type="submit"
                  className="button"
                  style={{ marginLeft: "20px" }}
                >
                  {showButtonData?.buttonLabel}
                </button>
              </form>
            ) : (
              <button
                className="button"
                disabled={true}
                style={{
                  cursor: "default",
                  pointerEvents: "none",
                  marginLeft: "20px",
                }}
              >
                {showButtonData?.buttonLabel}
              </button>
            ))
            
            }

         



          </div>
    </div>
    </>
  );
};

export default CommissionStateTdsPtaxDetails;
